<template>
  <div :class="[`loading`, isSmall ? `loading--bar--small` : `loading--bar--medium`]">
    <div class="loading__bar"></div>
    <div v-if="label" class="loading__label">{{ label }}</div>
  </div>
</template>

<script>
export default {
  name: "Bar",
  props: {
    label: {
      type: String,
      required: true,
    },
    isSmall: {
      type: Boolean,
      required: true,
    },
  },
};
</script>